import { Fragment, useState, useEffect, useRef, useMemo } from "react"
import { PropTypes } from "prop-types"
import { Col, Row, Media, Card, CardBody } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  getBlocks,
  startLesson,
  finishLesson,
  startLessonClean,
  finishLessonClean,
  listQuizz,
} from "store/actions"
import Notes from "components/Notes"
import SweetAlert from "react-bootstrap-sweetalert"
import QuizzUserFormModal from "./QuizzUserFormModal"
import moment from "moment"

const sortLessons = unorderedLessons =>
  [...unorderedLessons].sort((a, b) =>
    a.order === b.order && a.order === 0
      ? a.idLesson > b.idLesson
        ? 1
        : -1
      : a.order > b.order
      ? 1
      : -1
  )

const CoursesLessonsDetails = props => {
  const [selectedLessonId, setSelectedLessonId] = useState(null)
  const [lastLessonId, setLastLessonId] = useState(null)
  const [lastViewedLessonId, setLastViewedLessonId] = useState(null)
  const [viewQuizz, setViewQuizz] = useState(undefined)
  const [quizzesAnswered, setQuizzesAnswered] = useState(true)
  const [showLateral, setShowLateral] = useState(false)

  const lessons = props.lessons ?? []
  const progressLessons = props.progressLessons ?? []

  const sortedLessons = useMemo(() => sortLessons(lessons), [lessons])
  const selectedLessonIndex = useMemo(
    () => sortedLessons.findIndex(l => l.idLesson === selectedLessonId),
    [sortedLessons, selectedLessonId]
  )
  const lastViewedLessonIndex = useMemo(
    () => sortedLessons.findIndex(l => l.idLesson === lastViewedLessonId),
    [sortedLessons, lastViewedLessonId]
  )

  const dispatch = useDispatch()
  const ref = useRef(null)

  const {
    blocks,
    blocksLoading,
    lessonFinish,
    finishDone,
    finishLoading,
    startDone,
    startLoading,
    quizz,
    quizzLoading,
    quizzDone,
    whoIAm,
  } = useSelector(store => ({
    blocks: store.BlocksList.blocks,
    blocksLoading: store.BlocksList.loading,
    finishDone: store.LessonFinish.done,
    lessonFinish: store.LessonFinish.lesson,
    finishLoading: store.LessonFinish.loading,
    startDone: store.LessonStart.done,
    startLoading: store.LessonStart.loading,
    quizz: store.QuizzList.quizz,
    quizzLoading: store.QuizzList.loading,
    quizzDone: store.QuizzList.done,
    whoIAm: store.Profile.user,
  }))

  useEffect(() => {
    if (selectedLessonId !== null) {
      dispatch(getBlocks(selectedLessonId))
    }
    return () => setSelectedLessonId(null)
  }, [lessons])

  useEffect(() => {
    if (progressLessons !== undefined) {
        const startedLessons = [...progressLessons]
          .filter(value => value.started)
          .sort((a, b) => (a.startDate > b.startDate ? -1 : 1))
      if (startedLessons.length > 0) {
        const idLesson = startedLessons[0].idLesson
        setLastLessonId(idLesson)
      }
    }
  }, [progressLessons])

  useEffect(() => {
    if (selectedLessonId !== null) {
      dispatch(listQuizz(selectedLessonId, whoIAm.idUsuario))
    }
  }, [selectedLessonId])

  useEffect(() => {
    if (props.selectedLesson !== undefined) {
      props.cleanSelectedLesson()
      return
    }
    if (selectedLessonId === null && sortedLessons.length > 0) {
      const firstLessonId = sortedLessons[0].idLesson
      setSelectedLessonId(firstLessonId)
      dispatch(
        startLesson({
          idCourse: props.course.idCurso,
          idLesson: firstLessonId,
        })
      )
      handleChangeLesson(firstLessonId)
    }
  }, [sortedLessons, selectedLessonId])

  useEffect(() => {
    if (props.selectedLesson !== undefined || lastLessonId !== null) {
      const targetId = props.selectedLesson ?? lastLessonId
      if (targetId !== undefined && targetId !== null) {
        setSelectedLessonId(targetId)
        handleChangeLesson(targetId)
      }
    }
  }, [props.selectedLesson, lastLessonId])

  useEffect(() => {
    setQuizzesAnswered(handleQuizzesAnswered())
  }, [quizz])

  const handleChangeLesson = newLessonId => {
    setSelectedLessonId(newLessonId)
    const newIndex = sortedLessons.findIndex(l => l.idLesson === newLessonId)
    if (newIndex > lastViewedLessonIndex) {
      setLastViewedLessonId(newLessonId)
    }
    dispatch(getBlocks(newLessonId))
    if (ref.current)
      ref.current.scrollIntoView({
        behavior: "smooth",
      })
  }

  const handleFinishLesson = goToExam => {
    dispatch(
      finishLesson({
        idCourse: props.course.idCurso,
        idLesson: selectedLessonId,
      })
    )

    if (goToExam) props.goToExam()
  }

  const handleQuizzesAnswered = () => {
    if (quizz !== undefined && quizz.length > 0) {
      const pendingQuizzes = quizz.find(
        element => element.correct === undefined
      )
      return pendingQuizzes === undefined
    }
    return true
  }

  if (startDone) {
    dispatch(startLessonClean())
  }

  if (finishDone) {
    const percentage = lessonFinish.percentage
    props.reloadProgress(percentage)
    dispatch(finishLessonClean())
  }

  if (props.activeTab !== "2") return <div></div>

  return (
    <Fragment>
      <div
        style={{ position: "absolute", top: -50, left: 0, right: 0 }}
        ref={ref}
      ></div>
      <div className="mb-4 pb-4">
        <button
          className="btn btn-primary btn-block"
          onClick={() => setShowLateral(!showLateral)}
        >
          <i
            className={`fa fa-${
              showLateral ? "chevron-left" : "chevron-right"
            }`}
          ></i>{" "}
          {showLateral ? "Ocultar" : "Mostrar"} menú lateral
        </button>
      </div>
      <Row>
        {showLateral && (
          <Col md={4} lg={3}>
            <ul className="verti-timeline list-unstyled">
              {sortedLessons.map((lesson, index) => (
                  <li
                    key={`lesson-${lesson.idLesson}`}
                    className="event-list"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (
                        index <= lastViewedLessonIndex ||
                        index <= selectedLessonIndex
                      ) {
                        handleChangeLesson(lesson.idLesson)
                      }
                    }}
                  >
                    <div className="event-timeline-dot">
                      <i
                        className={`fa fa-circle font-size-18 ${
                          index === selectedLessonIndex
                            ? "alt-celf-color"
                            : index <= lastViewedLessonIndex ||
                              index <= selectedLessonIndex
                            ? "alt-celf-color-with-opacity"
                            : "with-opacity"
                        }`}
                      />
                    </div>
                    <Media>
                      <Media body>
                        <h3
                          className={
                            index === selectedLessonIndex
                              ? "alt-celf-color"
                              : index <= lastViewedLessonIndex ||
                                index <= selectedLessonIndex
                              ? "alt-celf-color-with-opacity"
                              : "with-opacity"
                          }
                        >
                          {lesson.title}
                        </h3>
                        <span>Lección {index + 1}</span>
                      </Media>
                    </Media>
                  </li>
                ))}
            </ul>
            <div className="mt-4">
              <Notes
                course={props.course}
                lesson={sortedLessons[selectedLessonIndex]}
              />
            </div>
          </Col>
        )}
        <Col
          md={!showLateral ? 12 : 8}
          lg={!showLateral ? 12 : 9}
          className=" bg-gray"
        >
          {blocks !== undefined &&
            blocks.map((block, index) => {
              if (block.type == "text") {
                return (
                  <Row
                    key={`block-${index}`}
                    className="border pt-3 pb-3"
                    style={{ height: "800px", overflow: "scroll" }}
                  >
                    <Col>
                      <h3>{sortedLessons[selectedLessonIndex]?.title}</h3>
                      <hr />
                      {blocksLoading && (
                        <div style={{ height: "320px" }}>
                          <div className="d-flex justify-content-center align-items-center h-100">
                            <span style={{ fontSize: "24px" }}>
                              <i className="fa fa-spinner fa-spin"></i> Cargando
                              contenido...
                            </span>
                          </div>
                        </div>
                      )}
                      {blocks !== undefined &&
                        !blocksLoading &&
                        blocks.map((block, index2) => {
                          if (block.type == "text") {
                            return (
                              <Card
                                key={`block-card-${index}-${index2}`}
                                className="card"
                              >
                                <CardBody>
                                  <div
                                    className="table-responsive"
                                    dangerouslySetInnerHTML={{
                                      __html: block.value,
                                    }}
                                  ></div>
                                </CardBody>
                              </Card>
                            )
                          }
                        })}
                      {quizz !== undefined && quizz.length > 0 && (
                        <Fragment>
                          <hr />
                          <h3 className="mt-4 mb-2">
                            Refuerza tu conocimiento de esta lección
                            respondiendo a las siguientes preguntas.
                          </h3>
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>Pregunta</th>
                                <th>Respuesta</th>
                                <th>Fecha</th>
                                <th>Ver</th>
                              </tr>
                            </thead>
                            <tbody>
                              {quizz?.map(singleQuizz => (
                                <tr key={`tr-quizz-${singleQuizz.quizzId}`}>
                                  <td>{singleQuizz.question}</td>
                                  <td className="text-center">
                                    {singleQuizz.correct === undefined ? (
                                      <span
                                        title="Pendiente"
                                        className="text-warning"
                                      >
                                        <i className="fa fa-clock"></i>
                                      </span>
                                    ) : singleQuizz.correct ? (
                                      <span
                                        title="Correcta"
                                        className="text-success"
                                      >
                                        <i className="fa fa-check"></i>
                                      </span>
                                    ) : (
                                      <span
                                        title="Incorrecta"
                                        className="text-danger"
                                      >
                                        <i className="fa fa-times"></i>
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {singleQuizz.registerUserDate === undefined
                                      ? "-"
                                      : moment(
                                          singleQuizz.registerUserDate
                                        ).format("D/MM/YYYY")}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      className="btn btn-primary btn-block"
                                      onClick={() => setViewQuizz(singleQuizz)}
                                    >
                                      <i className="fa fa-eye" /> Ver
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Fragment>
                      )}
                    </Col>
                  </Row>
                )
              }
              if (block.tyoe == "youtube") {
                var video_id = block.value.split("v=")[1]
                var ampersandPosition = video_id.indexOf("&")
                if (ampersandPosition != -1) {
                  video_id = video_id.substring(0, ampersandPosition)
                }
                return (
                  <iframe
                    key={`block-${index}`}
                    width="100%"
                    height="480"
                    src={`https://www.youtube.com/embed/${video_id}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                )
              }
            })}
          {!quizzesAnswered && (
            <div className="mt-2 mb-2 alert alert-warning">
              Por favor responda todas las respuestas para continuar a la
              siguiente lección.
            </div>
          )}
          <div
            className={`mt-4 mb-4 d-flex justify-content-center ${
              startLoading || finishLoading ? "d-none" : ""
            }`}
          >
            {selectedLessonIndex > 0 && (
              <button
                onClick={() => handleChangeLesson(sortedLessons[selectedLessonIndex - 1].idLesson)}
                className="btn btn-light mr-2"
              >
                <i className="fa fa-arrow-left"></i> Lección anterior
              </button>
            )}
            &nbsp;&nbsp;&nbsp;
            {sortedLessons.length > selectedLessonIndex + 1 && (
              <button
                onClick={() => {
                  handleFinishLesson(false)
                  handleChangeLesson(sortedLessons[selectedLessonIndex + 1].idLesson)
                }}
                className={`btn btn-secondary ml-2 ${
                  quizzesAnswered ? "" : "disabled"
                }`}
              >
                Siguiente lección <i className="fa fa-arrow-right"></i>
              </button>
            )}
            {sortedLessons.length === selectedLessonIndex + 1 && (
              <button
                onClick={() => handleFinishLesson(true)}
                className={`btn btn-secondary ml-2 ${
                  quizzesAnswered ? "" : "disabled"
                }`}
              >
                Ir al examen <i className="fa fa-medal"></i>
              </button>
            )}
          </div>
        </Col>
        <style jsx="true">{`
          .bg-gray {
            background-color: #f9f9f9;
          }
        `}</style>
      </Row>
      <QuizzUserFormModal
        quizz={viewQuizz}
        course={props.course}
        onAnswer={() => {
          dispatch(listQuizz(selectedLessonId, whoIAm.idUsuario))
        }}
        onClose={() => setViewQuizz(undefined)}
      />
      {lastLessonId !== null && props.activeTab === "2" && (
        <SweetAlert
          title="¿Desea continuar donde se quedó?"
          warning
          confirmBtnBsStyle="secondary"
          confirmBtnText="Continuar aquí"
          onConfirm={() => {
            setLastLessonId(null)
          }}
          showCancel={true}
          cancelBtnBsStyle="light"
          cancelBtnText="Regresar al inicio"
          onCancel={() => {
            setLastLessonId(null)
            handleChangeLesson(sortedLessons[0]?.idLesson)
          }}
        >
          <p>
            ¿Desea continuar el curso donde se quedó la última vez que ingresó
            al curso o quiere iniciar al inicio?
          </p>
        </SweetAlert>
      )}
    </Fragment>
  )
}

CoursesLessonsDetails.propTypes = {
  course: PropTypes.object,
  lessons: PropTypes.array,
  progressLessons: PropTypes.array,
  selectedLesson: PropTypes.number, // idLesson, not array index
  cleanSelectedLesson: PropTypes.func,
  reloadProgress: PropTypes.func,
  goToExam: PropTypes.func,
  activeTab: PropTypes.string,
}

export default CoursesLessonsDetails
